import { createContext, useContext } from "react";
import type { DatePickerContextValue } from "./types";

export const DatePickerContext = createContext<DatePickerContextValue | null>(
  null,
);

export function useDatePickerContext() {
  const ctx = useContext(DatePickerContext);
  if (!ctx) {
    throw new Error(
      "DatePicker sub-components must be used within <DatePicker>",
    );
  }
  return ctx;
}
